import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import axios from 'axios';
// 引入 element-plus
import 'element-plus/dist/index.css';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
// 引入moment
import moment from 'moment';


// 将 axios 添加到 Vue 的原型上
const app = createApp(App);

// 防止api报错
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}
// 注册全局方法
app.config.globalProperties.$http = axios;
// 全局store
app.config.globalProperties.$store = store;

// 使用 router 和 store
app.use(router);
app.use(store);

// 使用 ElementPlus
app.use(ElementPlus);
app.use(moment);

// 注册 ElementPlus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}



// 创建并挂载 Vue 实例
const vueInstance = app.mount('#app');
window.app = vueInstance;
